import { Basename } from '@/types/Basename';

export const getBasename = (): Basename => {
    let basename = Basename.ENUS;
    if (typeof window !== 'undefined' && window.location.pathname.includes(Basename.ENGB)) {
        basename = Basename.ENGB;
    }
    return basename;
};
